import { ref } from 'vue';
import Component from './component.vue'

export default {
  install: (app, options) => {
    app.component('notifications', Component);

    const getRandomString = (length = 10) => {
      let className = "";
      const characters = "abcdefghijklmnopqrstuvwxyz";
      for (var i = 0; i < length; i++) {
        className += characters.charAt(Math.floor(Math.random() * characters.length));
      }

      return className;
    }

    const notifications = ref([]);

    const show = (notification) => {
      const id = getRandomString();

      notifications.value.push({
        id: id,
        class: notification.class, // warning, error
        icon: notification.icon,
        title: notification.title,
        descr: notification.descr,
      });

      setTimeout(() => {
        hide(id);
      }, 5000);
    }

    const hide = (id) => {
      notifications.value.filter((element, index) => {

        if (element.id == id) {
          notifications.value.splice(index, 1);
        }
      });
    }

    const notification = { notifications, show, hide };

    app.config.globalProperties.$notification = notification;
    app.provide('$notification', notification);
  }
}